/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";

import { ToastContext } from "common/contexts";
import getData from "common/fetch/get";

import ButtonNew from "components/atoms/ButtonNew/index";
import Img from "components/atoms/Img";
import Progress from "components/atoms/Progress";
import Toast from "components/atoms/Toast/index";
import StepBar from "components/molecules/StepBar/index";

import FromStep1 from "./form/FormStep1";
import FromStep2 from "./form/FormStep2";
import FromStep3 from "./form/FormStep3";
import { FormSend } from "./SendForm/index";

import styles from "./Styles.module.scss";

const dataStep = [
  {
    id: 1,
    name: "Banking Requirement",
    sub_step: [],
  },
  {
    id: 2,
    name: "Personal Freference",
    sub_step: [],
  },
  {
    id: 3,
    name: "Successful Rate Assessment",
    sub_step: [],
  },
];

const Tool = () => {
  // Const { openAlert } = useContext(ToastContext);
  const [step, setStep] = useState(1);
  const [countries, setCountries] = useState([]);
  const [dataBanks, setDataBanks] = useState([]);
  const [form1Data, setForm1Data] = useState({ values: { businessField: "" } });
  const [form2Data, setForm2Data] = useState({});
  const [scoreResult, setScoreResult] = useState({
    percentage: 0,
    status: "NONE",
  });
  const [screenToggle, setScreenToggle] = useState(1);
  const [errorsForm1, setErrorsForm1] = useState({});
  const { openAlert, setOpenAlert } = useContext(ToastContext);

  const savedBanks = useRef([]);
  const {
    clearErrors,
    reset,
    formState: { isSubmitting, errors },
  } = useForm();

  async function fetchCountries() {
    const response = await getData({
      url: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/country`,
    });

    if (response.data && response.data.length > 0) {
      setCountries(
        response.data.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }))
      );
    }
  }

  useEffect(() => {
    try {
      // Async function fetchCountries() {
      //   Const response = await axios.get(
      //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/country`
      //   );
      //   If (response.data && response.data.data) {
      //     SetCountries(
      //       Response.data.data.map((item) => ({
      //         ...item,
      //         Label: item.name,
      //         Value: item.id,
      //       }))
      //     );
      //   }
      // }

      fetchCountries();
    } catch (error) {
      console.error();
    }
  }, []);

  useEffect(() => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
    if (errors.email) {
      clearErrors();
    }
  }, [step]);

  const toggleScreen = () => {
    if (screenToggle === 1) {
      setScreenToggle(2);
    } else {
      setScreenToggle(1);
    }
  };

  const isNextDisabled = () => {
    if (step === 3 || dataBanks.length === 0) {
      return true;
    }
    if (step === 1) {
      const { values } = form1Data;
      const con1 =
        !values.incorporationCountry || !values.incorporationCountry.value;
      const con2 = !values.businessField || values.businessField.trim() === "";
      const con3 = !values.merchantAccount;
      const con4 =
        !values.memberNationalities ||
        !Array.isArray(values.memberNationalities) ||
        (Array.isArray(values.memberNationalities) &&
          values.memberNationalities.length === 0);
      const con5 =
        !values.partnerCountries ||
        !Array.isArray(values.partnerCountries) ||
        (Array.isArray(values.partnerCountries) &&
          values.partnerCountries.length === 0);

      return con1 || con2 || con3 || con4 || con5;
    }
    if (step === 2) {
      return !form2Data.deposit || !form2Data.isRemote;
    }
  };

  const onNext = () => {
    if (!isNextDisabled()) {
      if (step === 1) {
        savedBanks.current = dataBanks;
      }
      if (step < 3) {
        setStep(step + 1);
      }
    }
  };

  const onBack = () => {
    if (step === 3) {
      setScoreResult({ percentage: 0, status: "NONE" });
    }
    if (step === 2) {
      setDataBanks(savedBanks.current);
      setForm2Data({});
    }
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleReset = () => {
    setForm1Data({ values: { businessField: "" } });
    setForm2Data({});
    setStep(1);
    setScoreResult({ percentage: 0, status: "NONE" });
    setDataBanks([]);
    savedBanks.current = [];
    // ClearErrors();
    reset({ email: "" });
    setErrorsForm1({});
  };

  const onResetClick = () => {
    const isResetDisabled =
      Object.keys(form1Data.values).length <= 1 &&
      form1Data.values.businessField === "";

    if (!isResetDisabled) {
      openAlert(false, "custom", {
        bgAlert: "bg-white",
        element: (
          <>
            <Img
              src="/assets/icons/warning.png"
              width={98}
              height={100}
              alt="icon error"
              className="mx-auto mb-6"
              wrapper={{
                className: "block",
              }}
            />
            <p className="mb-6 text-2xl font-semibold text-bbc-brand-700">
              Are you sure?{" "}
            </p>
            <div className="flex justify-around">
              <ButtonNew
                variant="outline"
                btnTextColor={"text-bbc-red-300 hover:text-white"}
                btnBorder={"border border-bbc-red-300 hover:border-bbc-red-400"}
                btnColor={"bg-transparent hover:bg-bbc-red-400"}
                othersClass={"w-28"}
                onClick={() => {
                  setOpenAlert(false);
                }}
              >
                No
              </ButtonNew>
              <ButtonNew
                othersClass={"w-28"}
                onClick={() => {
                  handleReset();
                  setOpenAlert(false);
                }}
              >
                Yes
              </ButtonNew>
            </div>
          </>
        ),
      });
    }
  };

  const onTalkClick = async () => {
    // eslint-disable-next-line no-undef
    await Tawk_API.toggle();
  };

  return (
    <>
      <div className={`container ${styles.wrapper}`}>
        <div className="mb-0 lg:mb-10">
          <StepBar step={step} data={dataStep} />
        </div>
        <div className="row">
          <div
            className={`col-12 lg:col-8 lg:block ${
              screenToggle === 1 ? "block" : " hidden"
            }`}
          >
            <div className="lg:shadow-bbc h-full rounded-lg bg-inherit px-0 py-0 shadow-none lg:bg-white lg:px-16 lg:py-10">
              {step === 1 && (
                <FromStep1
                  countries={countries}
                  form1Data={form1Data}
                  setForm1Data={setForm1Data}
                  setDataBanks={setDataBanks}
                  errors={errorsForm1}
                  setErrors={setErrorsForm1}
                />
              )}
              {step === 2 && (
                <FromStep2
                  dataBanks={dataBanks}
                  setDataBanks={setDataBanks}
                  form2Data={form2Data}
                  setForm2Data={setForm2Data}
                  savedBanks={savedBanks}
                />
              )}
              {step === 3 && (
                <FromStep3
                  dataBanks={dataBanks}
                  setScoreResult={setScoreResult}
                />
              )}

              <div className="mb-6 flex justify-between lg:mb-10">
                <button
                  onClick={onBack}
                  disabled={step === 1 || isSubmitting}
                  className={`${
                    step === 1 || isSubmitting
                      ? "cursor-not-allowed text-bbc-neutral-600"
                      : "cursor-pointer text-bbc-brand-500"
                  } font-medium`}
                >
                  Back
                </button>
                <button
                  onClick={onResetClick}
                  disabled={
                    (Object.keys(form1Data.values).length <= 1 &&
                      form1Data.values.businessField === "") ||
                    isSubmitting
                  }
                  className={`${
                    (Object.keys(form1Data.values).length <= 1 &&
                      form1Data.values.businessField === "") ||
                    isSubmitting
                      ? "cursor-not-allowed text-bbc-neutral-600"
                      : "cursor-pointer text-bbc-brand-500"
                  } btn-outline-primary font-medium`}
                >
                  Reset
                </button>
                <button
                  onClick={onNext}
                  disabled={isNextDisabled() || isSubmitting}
                  className={`${
                    isNextDisabled() || isSubmitting
                      ? "cursor-not-allowed text-bbc-neutral-600"
                      : "cursor-pointer text-bbc-brand-500"
                  } btn-outline-primary font-medium `}
                >
                  Next
                </button>
              </div>
              {step === 3 && (
                <div className="mb-6 lg:mb-10">
                  <p className="mb-4 text-center font-medium">
                    Need more support with your banking choices and application?
                    Leave your details and we’ll get in touch.
                  </p>
                  <div className="row m-0 mb-2 justify-center">
                    <Toast>
                      <FormSend
                        haveCheckBox={true}
                        checkedId={21}
                        unCheckId={23}
                        triggerName="Banking Tool"
                        apiLink="/api/portal/contact_form/minitool_contact"
                        form1Data={form1Data}
                        step={step}
                      />
                    </Toast>
                  </div>
                  <p className="mb-2 text-center">Or</p>
                  <div className="text-center">
                    <ButtonNew onClick={onTalkClick}>Talk To Us</ButtonNew>
                  </div>
                </div>
              )}
              <div>
                <p className="mb-2 font-medium">*Note:</p>
                <p className="text-sm font-normal italic">
                  The information provided in this tool is for general reference
                  purpose only. We strongly recommend you contacting us to
                  receive specific advice contingent on your case.
                </p>
              </div>
            </div>
          </div>
          <div
            className={`col-12 flex-col lg:col-4 lg:flex ${
              screenToggle === 2 ? "" : "hidden"
            }`}
          >
            <div className="lg:shadow-bbc mb-0 rounded-lg bg-bbc-main p-6 shadow-none lg:mb-6 lg:bg-white">
              <p className="mb-4 text-center font-medium">
                Your chances of getting approved
              </p>
              <div className="text-center">
                <Progress
                  percent={scoreResult.percentage}
                  text={scoreResult.status}
                  strokeWidth="7"
                  trailWidth="7"
                  strokeColor="#007EFF"
                  trailColor="#E5E5E5"
                  className="inline-block"
                  style={{ width: "170px" }}
                />
              </div>
            </div>
            <div className="lg:shadow-bbc flex-auto rounded-lg bg-bbc-main px-0 py-6 shadow-none lg:bg-white lg:px-6">
              <p className="mb-4 text-center lg:text-left">
                List of proposed banks based on your answers (in desc order of
                suitability)
              </p>
              <div className="mb-2">
                <span className="font-medium text-bbc-brand-500">Bank: </span>
                <span>
                  {dataBanks.length === 0 ? "No results" : dataBanks.length}
                </span>
              </div>

              <div className="overflow-y-auto" style={{ height: "480px" }}>
                {dataBanks.map((bank, index) => {
                  return (
                    <div
                      key={index}
                      className="mb-2 flex justify-between rounded-md border border-bbc-neutral-500 p-2"
                    >
                      <div>
                        <p className="mb-1 font-medium">{bank.name}</p>
                        <p className="text-xs font-normal">
                          {bank?.Country?.name}
                        </p>
                      </div>
                      <Img
                        src={`assets${bank.image}`}
                        wrapper={{
                          className: "self-center",
                        }}
                        alt="bank"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={toggleScreen}
        className={
          "text-uppercase fixed bottom-0 z-20 flex w-full justify-center bg-white px-0 py-5 font-medium text-bbc-primary lg:hidden"
        }
        style={{ boxShadow: "0 -4px 8px rgb(0 0 0 / 25%)" }}
      >
        {screenToggle === 1 && "YOUR RESULT IN HERE"}
        {screenToggle === 2 && "BACK"}
      </div>
    </>
  );
};

export default function BankingTool({ data }) {
  return (
    <Toast>
      <Tool data={data} />
    </Toast>
  );
}
